<!-- 物业管理详情 -->
<style lang="scss" scoped>
.propertypage {
  position: relative;

  .left-content {
    position: absolute;
    width: 416px;
    height: 850px;
    left: 107px;
    top: 135px;
  }

  .right-content {
    position: absolute;
    width: 416px;
    height: 881px;
    top: 135px;
    right: 42px;
  }
}
</style>

<template>
  <div class="propertypage">
    <custom-return></custom-return>
    <div class="left-content">
      <CameraCenter :online="online" :abnormal="abnormal"></CameraCenter>
      <EquOpe
        :numb1="numb1"
        :numb2="numb2"
        :numb3="numb3"
        :numb4="numb4"
      ></EquOpe>
      <NhManage :energy="energy"></NhManage>
    </div>
    <div class="right-content">
      <EnvWatch :envList="envList"></EnvWatch>
      <ParkingManage :text1="text1" :text2="text2"></ParkingManage>
      <!-- 
      <XgManage :xgNum1="0" :xgNum2="0"></XgManage>
      <StankingBook :account="'0/0'" :money="'0'"></StankingBook>
      <VisitorManage></VisitorManage> -->
    </div>
  </div>
</template>
<script>
import CameraCenter from "./components/camera-center.vue";
import EquOpe from "./components/equ-ope.vue";
import ParkingManage from "./components/parking-manage.vue";
import NhManage from "./components/nh-manage.vue";
import XgManage from "./components/xg-manage.vue";
import EnvWatch from "./components/env-watch.vue";
import VisitorManage from "./components/visitor-manage.vue";
import StankingBook from "./components/stanking-book.vue";
import { getHomePageData } from "@/api/index";
export default {
  components: {
    CameraCenter,
    EquOpe,
    ParkingManage,
    NhManage,
    XgManage,
    EnvWatch,
    VisitorManage,
    StankingBook,
  },
  data() {
    return {
      timer: null,
      energy: [
        {
          title: "水总能耗",
          eneData: "0",
          company: "m³",
          imgs: require("@/assets/compImg/icon/Triangular2.png"),
        },
        {
          title: "电总能耗",
          eneData: "0",
          company: "kwh",
          imgs: require("@/assets/compImg/icon/Triangular1.png"),
        },
        {
          title: "气总能耗",
          eneData: "-",
          company: "L",
          imgs: require("@/assets/compImg/icon/line.png"),
        },
      ],
      envList: [
        { no: "PM2.5", env_numb: "0.0", env_company: "μg/m³", alarm: "" },
        { no: "TSP", env_numb: "0", env_company: "μg/m³", alarm: "" },
        { no: "PM10", env_numb: "0", env_company: "μg/m³", alarm: "" },
        { no: "噪声", env_numb: "0", env_company: "dB", alarm: "" },
      ],
      online: "0",
      abnormal: 0,
      // 设备运维
      numb1: 0,
      numb2: 0,
      numb3: 0,
      numb4: 0,
      // 停车
      text1: "0/0",
      text2: "0/0",
    };
  },
  created() {
    this.ReqHomePageData();
    this.timer = setInterval(() => {
      this.ReqHomePageData();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 首页数据
    async ReqHomePageData() {
      let { data: res } = await getHomePageData();
      // console.log(res);
      if (!res) return;
      // 监控中心
      this.online = res.monitor.onlineRate;
      this.abnormal = res.monitor.fault;
      // 设备运维
      this.numb1 = res.eqpOperation.total;
      this.numb2 = res.eqpOperation.normal;
      this.numb3 = res.eqpOperation.offLine;
      this.numb4 = res.eqpOperation.fault;
      // 停车管理
      this.text1 = res.park.park;
      this.text2 = res.park.barrierGate;

      // 能耗
      this.energy[0].eneData = res.energy.waterEnergy;
      this.energy[1].eneData = Number(res.energy.electricityEnergy).toFixed(2);

      // 环境监测
      this.envList[0].env_numb = res.environment.TSP.value.split("μg/m³")[0];
      this.envList[1].env_numb = res.environment["PM2.5"].value.split(
        "μg/m³"
      )[0];
      this.envList[2].env_numb = res.environment.noise.value.split("db")[0];
      this.envList[3].env_numb = res.environment.PM10.value.split("μg/m³")[0];

      this.envList[0].alarm = res.environment.TSP.alarm;
      this.envList[1].alarm = res.environment["PM2.5"].alarm;
      this.envList[2].alarm = res.environment.noise.alarm;
      this.envList[3].alarm = res.environment.PM10.alarm;
    },
  },
};
</script>
